import { Injectable } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';

import { BrowseFilter } from '../models/filter';
import { BrowseSorting } from '../models/sorting';
import { Sport } from '../models/sport';
import { FilterStore } from '../store/filter/filter.store';
import { SearchedContentStore } from '../store/searched-content/searched-content.store';
import { SearchedTermStore } from '../store/searched-term/searched-term.store';
import { SortingStore } from '../store/sorting/sorting.store';
import { SportStore } from '../store/sport/sport.store';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private subscriptions: Subscription[];

  constructor(
    private sportStore: SportStore,
    private filterStore: FilterStore,
    private sortingStore: SortingStore,
    private searchedTermStore: SearchedTermStore,
    private searchedContentStore: SearchedContentStore,

  ) {
    this.subscriptions = [];
  }

  subscribeToFetch(): void {
    this.subscriptions.push(
      this.subscriptionToFetchSearchedContentsWhenSportTermFiltersOrSortingChange(),
      this.subscriptionToFetchSearchedPlaylistsWhenSportOrTermChanges()
    );
  }

  unsubscribeToFetch(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
  }

  private subscriptionToFetchSearchedContentsWhenSportTermFiltersOrSortingChange(): Subscription {
    return combineLatest([
      this.sportStore.selectedSport$,
      this.searchedTermStore.searchedTerm$,
      this.filterStore.searchedContentFilters$,
      this.sortingStore.searchedContentSorting$,
    ]).subscribe((res: [Sport, string, BrowseFilter[], BrowseSorting]) => {
      const selectedSport: Sport = res[0];
      const searchedTerm: string = res[1];
      const searchContentFilters: BrowseFilter[] = res[2];
      const searchContentSorting: BrowseSorting = res[3];
      this.searchedContentStore.getSearchedContents({
        newSelectedSport: selectedSport,
        newSearchedTerm: searchedTerm,
        newFilters: searchContentFilters,
        newSorting: searchContentSorting,
        isNextPage: false,
      });
    });
  }

  private subscriptionToFetchSearchedPlaylistsWhenSportOrTermChanges(): Subscription {
    return combineLatest([
      this.sportStore.selectedSport$,
      this.searchedTermStore.searchedTerm$,
    ]).subscribe((res: [Sport, string]) => {
      const selectedSport: Sport = res[0];
      const searchedTerm: string = res[1];
      this.searchedContentStore.getSearchedPlaylists({
        newSelectedSport: selectedSport,
        newSearchedTerm: searchedTerm,
      });
    });
  }
}
